import type { ProgressButtonState } from "@shared/ui";
import type { AbstractStepProps, AbstractStepState } from "./AbstractStep";
import { AbstractStep } from "./AbstractStep";

export interface AbstractSubmitStepProps extends AbstractStepProps {
	submitState: ProgressButtonState;
}

export abstract class AbstractSubmitStep<
	FormFields extends Record<string, any> = {},
	Props extends AbstractSubmitStepProps = AbstractSubmitStepProps,
	State extends AbstractStepState = AbstractStepState,
> extends AbstractStep<FormFields, Props, State> {
	protected isDisabled(): boolean {
		const { submitState } = this.props;

		return submitState !== undefined;
	}
}
